<div class="item-wrapper" [style.grid-template-columns]="gridTemplate || null">
    @for (column of columns; track column) {
        @if (column.isDisplayed) {
            @switch (column.value) {
                @case ('type') {
                    <div class="field">
                        <span>{{ formTypeList | getFormType:template.formTypeSettings[column.value] }}</span>
                    </div>
                }
                @case ('category') {
                    <div class="field">
                        <span>{{ template.formTypeSettings[column.value] | getFormCategory }}</span>
                    </div>
                }
                @case ('industries') {
                    <div class="field">
                        <span>{{ industriesLabel }}</span>
                    </div>
                }
                @case ('owner') {
                    <div class="field">
                        <p-tag
                            styleClass="status-tag"
                            [severity]="template?.account ? 'secondary' : 'info'"
                            [value]="template?.account?.name || 'RISE'"></p-tag>
                    </div>
                }
                @default {
                    <div class="field">
                        <span>{{ template[column.value] }}</span>
                    </div>
                }
            }
        }
    }

    <div class="button-container">
        @if (template?.account) {
            <button class="btn-tertiary-link" (click)="clone()">Duplicate</button>
            <button class="btn-secondary" (click)="edit()">Edit</button>
        } @else {
            <button class="btn-tertiary-link" (click)="openPreview()">Preview</button>
            <button class="btn-secondary" (click)="clone()">Add Report</button>
        }
    </div>
</div>


<div class="item-wrapper-mobile">
    <app-flight-card-mobile [content]="'grid'">
        <ng-container title>
            {{template.title}}
        </ng-container>

        <ng-container content>
            @for (column of columns; track column) {
                @if (column.isDisplayed) {
                    @switch (column.value) {
                        @case ('title') {}
                        @case ('type') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ formTypeList | getFormType:template.formTypeSettings[column.value] }}</span>
                            </div>
                        }
                        @case ('category') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ template.formTypeSettings[column.value] | getFormCategory }}</span>
                            </div>
                        }
                        @case ('industries') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ industriesLabel }}</span>
                            </div>
                        }
                        @case ('owner') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <p-tag
                                    styleClass="status-tag"
                                    [severity]="template?.account ? 'secondary' : 'info'"
                                    [value]="template?.account?.name || 'RISE'"></p-tag>
                            </div>
                        }
                        @default {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{column.value}}</span>
                            </div>
                        }
                    }
                }
            }
        </ng-container>

        <ng-container actions>
            <div class="flex gap-3 w-full">
                @if (template?.account) {
                    <button
                        class="btn-tertiary-link flex-1"
                        (click)="clone()">
                        Duplicate
                    </button>
                    <button class="btn-secondary flex-1" (click)="edit()">
                        Edit
                    </button>
                } @else {
                    <button
                        class="btn-tertiary-link flex-1"
                        (click)="openPreview()">
                        Preview
                    </button>
                    <button class="btn-secondary flex-1" (click)="clone()">
                        Add Report
                    </button>
                }
            </div>
        </ng-container>
    </app-flight-card-mobile>
</div>
